"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentState = void 0;
var PaymentState;
(function (PaymentState) {
    PaymentState[PaymentState["Presented"] = 1] = "Presented";
    PaymentState[PaymentState["Authorizing"] = 2] = "Authorizing";
    PaymentState[PaymentState["Authorized"] = 3] = "Authorized";
    PaymentState[PaymentState["Expired"] = 4] = "Expired";
    PaymentState[PaymentState["Cancelled"] = 5] = "Cancelled";
    PaymentState[PaymentState["PendingCapture"] = 6] = "PendingCapture";
    PaymentState[PaymentState["Capturing"] = 7] = "Capturing";
    PaymentState[PaymentState["Captured"] = 8] = "Captured";
    PaymentState[PaymentState["AuthorizationFailed"] = 9] = "AuthorizationFailed";
    PaymentState[PaymentState["CaptureFailed"] = 10] = "CaptureFailed";
})(PaymentState = exports.PaymentState || (exports.PaymentState = {}));
